import {
  Box,
  createStyles,
  LinearProgressProps,
  makeStyles,
  Step,
  StepLabel,
  Stepper,
  withStyles
} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress/LinearProgress";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useWindowSize from "../../../../../helper/hooks/useWindowSize";
import UtilService from "../../../../../helper/service";
import { moveNextPage } from "../../../../../store/actions/creator/creatorOnBoarding";

const CustomLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 25,
      borderRadius: 20,
    },
    colorPrimary: {
      backgroundColor: "#fff",
    },
    bar: {
      backgroundColor: "#017AEF"
    }
  })
)(LinearProgress);

const useStyles = makeStyles(() => ({
  moduleText: {
    fontFamily: 'roboto-light',
    fontSize: (props: any) => props.width < 1320 ? 18 : 20,
    color: '#212D40',
    '@media (max-width: 600px)': {
      fontSize: '15px!important'
    },
  },
  timeText: {
    fontFamily: 'roboto-light',
    fontSize: (props: any) => props.width < 1320 ? 12 : 14,
    color: '#212D40',
    marginTop: 5,
    '@media (max-width: 600px)': {
      marginTop: 2,
    },
  },
  topbar: {
    position: 'fixed',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#E4E9EF',
    padding: '10px 38px',
    zIndex: 1000,
    boxShadow: "0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 1px 0px 0px rgb(0 0 0 / 12%)",
    "& p": {
      margin: 0,
      maxWidth: '370px',
      width: '100%',
      color: "#697683",
      fontSize: 14,
    },
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  percentageLabel: {
    position: 'absolute',
    fontSize: 14,
    fontFamily: 'roboto-bold',
    right: '5%',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  stepLabel: {
    '& span': {
      padding: 0
    },
    '& svg': {
      color: 'white',
      width: 28,
      height: 28
    },
    '& text': {
      fontFamily: 'roboto-bold',
      fontSize: 12,
      fill: '#697683'
    }
  },
  activeStepLabel: {
    '& span': {
      padding: 0
    },
    '& svg': {
      width: 28,
      height: 28
    },
    '& text': {
      fontFamily: 'roboto-bold!important',
      fontSize: '12px!important',
      fill: 'white!important'
    }
  },
  completedStepLabel: {
    '& span': {
      padding: 0
    },
    '& svg': {
      width: 28,
      height: 28
    },
    '& .MuiStepIcon-root.MuiStepIcon-completed': {
      color: '#212D40'
    }
  },
  tabIcon: {
    width: 15,
    height: 15,
    cursor: 'pointer'
  },
  stepDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media (max-width: 600px)': {
      width: '100%',
      marginTop: 5
    },
  },
  stepper: {
    padding: 0,
    width: '90%',
    backgroundColor: 'unset',
  },
  progressDiv: {
    flex: 1,
    marginLeft: '2%',
    marginRight: '8%',
    '@media (max-width: 600px)': {
      display: 'none'
    },
  }
}));

const steps = ['', '', '', ''];

interface IProps {
  onShowPopup: () => void
}

const OnboardingTopbar = (props: IProps) => {
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const { onShowPopup } = props;
  const { page, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { videoplayed, tagtoggled, activestep } = userPreferences;
  const [progressPercentage, setProgressPercentage] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [topTitle, setTopTitle] = useState('');
  const [topSubTitle, setTopSubTitle] = useState('');
  const { width } = useWindowSize();

  useEffect(() => {
    onSetProgressPercentage(page);
    onSetActiveStep(page);
  }, [page, videoplayed, tagtoggled]);

  const onSetActiveStep = (selectedPage: number) => {
    if (selectedPage <= 8) {
      setActiveStep(0);
      setTopTitle('Module 1: Learn How Immersion Works');
      setTopSubTitle('Estimated time: 4 minutes');
    }
    if (selectedPage >= 9 && selectedPage <= 11) {
      setActiveStep(1);
      setTopTitle('Module 2: Measure A Video');
      setTopSubTitle('Estimated time: 2 minutes');
    }
    if (selectedPage >= 12 && selectedPage <= 13) {
      setActiveStep(2);
      setTopTitle('Module 3: Schedule a Neuro-Consult');
      setTopSubTitle('Estimated time: 2 minutes');
    }
    if (selectedPage >= 14) {
      setActiveStep(3);
      setTopTitle('Module 4: Review Results');
      setTopSubTitle('Estimated time: 5 minutes');
    }
    if (selectedPage === 16) {
      setActiveStep(4);
    }
  };

  const onSetProgressPercentage = (selectedPage: number) => {
    switch (selectedPage) {
      case 2:
        setProgressPercentage(14);
        break;
      case 3:
        setProgressPercentage(28);
        break;
      case 4:
        setProgressPercentage(42);
        break;
      case 5:
        setProgressPercentage(56);
        break;
      case 6:
        setProgressPercentage(70);
        break;
      case 7:
        setProgressPercentage(84);
        break;
      case 8:
        setProgressPercentage(100);
        break;
      case 9:
        setProgressPercentage(33);
        break;
      case 10:
        setProgressPercentage(67);
        break;
      case 11:
        setProgressPercentage(100);
        break;
      case 12:
        setProgressPercentage(56);
        break;
      case 13:
        setProgressPercentage(100);
        break;
      case 14:
        setProgressPercentage(0);
        break;
      case 15:
        if (!videoplayed.value) setProgressPercentage(25);
        if (videoplayed.value) setProgressPercentage(50);
        if (tagtoggled.value) setProgressPercentage(75);
        break;
      case 16:
        setProgressPercentage(100);
        break;
    }
  };

  const LinearProgressWithLabel = (props: LinearProgressProps & { value: number }) => {
    return (
      <Box width="100%" style={{ position: 'relative' }}>
        <CustomLinearProgress {...props} />
        <span className={classes.percentageLabel} style={{ color: Math.round(props.value) >= 85 ? '#FFFFFF' : '#017AEF' }}>
          {`${Math.round(props.value,)}%`}
        </span>
      </Box>
    );
  };

  const getStepLabelClass = useCallback((index: number) => {
    if (activeStep >= 4) {
      return classes.completedStepLabel;
    }
    return index === activeStep ? classes.activeStepLabel : classes.stepLabel;
  }, [activeStep]);

  const goStep = useCallback((stepIndex: number) => {
    if (Number(activestep.value) >= stepIndex) {
      switch (stepIndex) {
        case 0:
          dispatch(moveNextPage(2));
          break;
        case 1:
          dispatch(moveNextPage(9));
          break;
        case 2:
          dispatch(moveNextPage(12));
          break;
        case 3:
          dispatch(moveNextPage(14));
          break;
      }
    }
  }, [activestep]);

  const mousePointer = useCallback((stepIndex: number) => {
    return stepIndex <= Number(activestep.value);
  }, [activestep]);

  return (
    <div
      className={classes.topbar}
      style={{
        position: page === 15 ? 'fixed' : 'relative',
        width: (page === 15 && width >= 960) ? 'calc(100% - 65px)' : '100%'
      }}
    >
      <div style={{ flex: 1 }}>
        {!(page === 15 && width < 600) && <div className={classes.moduleText}>{topTitle}</div>}
        <div className={classes.timeText}>{topSubTitle}</div>
      </div>

      <div className={classes.progressDiv}>
        <LinearProgressWithLabel variant="determinate" value={progressPercentage} />
      </div>

      <div className={classes.stepDiv} style={{ flex: 1 }}>
        <Stepper activeStep={activeStep} className={classes.stepper}>
          {steps.map((label, index) => (
            <Step key={index} style={{ padding: 0 }} onClick={() => goStep(index)}>
              <StepLabel className={getStepLabelClass(index)} style={{ cursor: mousePointer(index) ? 'pointer' : 'unset' }}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        {page !== 17 && (
          <img
            src={'/assets/icons/onboarding/onboarding-topbar-tab.svg'}
            className={classes.tabIcon}
            alt={'GoTab'}
            onClick={() => onShowPopup()}
          />
        )}
      </div>
    </div>
  )
};

export default OnboardingTopbar